const drawerLink = document?.querySelectorAll('.drawerLink');
const productDrawer = document?.getElementById('productDrawer');
const drawerOverlay = document?.getElementById('drawerOverlay');
const drawerContent = productDrawer?.querySelector('.drawerContent');
const drawerHeading = productDrawer?.querySelector('.drawerHeading');
const closeIcon = productDrawer?.querySelector('.closeIcon');

if (productDrawer) {
  console.log(drawerLink);
  drawerLink.forEach((link) => {
    link.addEventListener('click', () => {
      const data = link.getAttribute('data-drawer');
      const getDrawerData = JSON.parse(data);
      console.log(getDrawerData?.image);
      drawerHeading.innerHTML = getDrawerData?.heading;

      if (productDrawer.classList.contains('activeDrawer') && getDrawerData.heading === link.textContent) {
        productDrawer.classList.remove('activeDrawer');
        drawerOverlay.classList.remove('activeDrawerOverlay');
      } else {
        productDrawer.classList.add('activeDrawer');
        drawerOverlay.classList.add('activeDrawerOverlay');

        productDrawer.classList.remove('hideDrawer');
        drawerOverlay.classList.remove('hideDrawerOverlay');
      }

      if (getDrawerData?.image) {
        const img = document.createElement('img');
        img.src = getDrawerData?.image;
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';

        drawerContent.innerHTML = '';
        drawerContent.appendChild(img);
        return;
      }

      if (drawerContent) {
        drawerContent.innerHTML = [1, 2, 3, 4, 5]
          .map((_, idx) => {
            const title = getDrawerData?.[`point_${idx}_title`];
            const desc = getDrawerData?.[`point_${idx}_desc`];

            if (title && desc) {
              return `
                <div class="details">
                <p>${title}</p>
                <p>${desc}</p>
                </div>
                `;
            } else {
              return `
                  <div class="details" style="display: none;">
                  <p></p>
                  <p></p>
                  </div>
                  `;
            }
          })
          .join('');
      }
    });
  });

  closeIcon.addEventListener('click', () => {
    productDrawer.classList.remove('activeDrawer');
    drawerOverlay.classList.remove('activeDrawerOverlay');

    productDrawer.classList.add('hideDrawer');
    drawerOverlay.classList.add('hideDrawerOverlay');
  });

  drawerOverlay.addEventListener('click', () => {
    productDrawer.classList.remove('activeDrawer');
    drawerOverlay.classList.remove('activeDrawerOverlay');

    productDrawer.classList.add('hideDrawer');
    drawerOverlay.classList.add('hideDrawerOverlay');
  });
}
